var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenYouTubeSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "3.48 5.75 23.04 18.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashicons:youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0871 8.2324C25.7991 7.2244 25.0791 6.5044 24.0711 6.2164C21.0471 5.9284 18.0231 5.6404 14.9991 5.7844C11.9751 5.7844 8.95114 5.9284 5.92714 6.2164C5.06314 6.5044 4.19914 7.3684 3.91114 8.2324C3.33691 12.7261 3.33691 17.2747 3.91114 21.7684C4.19914 22.7764 4.91914 23.4964 5.92714 23.7844C8.95114 24.0724 11.9751 24.3604 14.9991 24.2164C18.0231 24.2164 21.0471 24.0724 24.0711 23.7844C25.0791 23.4964 25.7991 22.7764 26.0871 21.7684C26.6614 17.2747 26.6614 12.7261 26.0871 8.2324ZM12.1191 19.3204V10.6804L19.6071 15.0004L12.1191 19.3204Z",
    fill: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenYouTubeSvg);
export default __webpack_public_path__ + "static/media/GoldenYouTubeSvg.cacc6b49b3c889ab692e5780dec5685a.svg";
export { ForwardRef as ReactComponent };